export enum StorageKeys {
    CheckoutSessionState = "checkout-session-state",
    CheckoutGuestDetailsState = "checkout-guest-details-state",
    TrackedEcommercePurchaseEventForProperties = "tracked-ecommerce-purchase-event-for-properties",
}
